<template>
  <div>
     <v-toolbar :dark="$dark()" dense flat>
      <!--
      <v-toolbar-items>
        <v-btn flat color="deep-orange">Events</v-btn>
        <v-btn flat color="deep-orange">Highlights</v-btn>

       </v-toolbar-items>
      <v-toolbar-title></v-toolbar-title>
-->
    </v-toolbar>

		<template v-for="info in grouped_events">
			<h3 style="margin-top: 20px">{{info.timestamp | format_date}}</h3>
			<v-list two-line dense>
				<template v-for="(event,index) in sorted(info.events)">
					<cloud-rec-event :event="event" :key="event.uuid" :start="start" :end="end"></cloud-rec-event>
   				<v-divider v-if="index + 1 < events.length"></v-divider>
   			</template>
	   	</v-list>
   	</template>

    <v-btn @click="load_next" v-if="show_button" v-observe-visibility="{callback: visibility_changed, once: false}">Load next {{page_size}}</v-btn>

    <v-toolbar v-if="issearch" :color="$dark() ? 'grey darken-4' : 'white'" fixed dense right style="top: 87px; left: auto; right: 90px; max-width: 500px;">
      <v-text-field color="deep-orange" prepend-icon="search" v-model="event_search" ref="search_field" clearable hide-details single-line></v-text-field>
      <v-card style="position: absolute; top: 48px; left: 0px ;width: 500px; margin-top: 0px; padding-top: 0px;" class="elevation-5">
        <event-search style="overflow: auto; max-height: 500px;" :search="event_search" url-prefix="/cloudrec/event/"></event-search>
      </v-card>
    </v-toolbar>

  </div>
</template>

<script>
import datelib from '@/lib/date.js';
import moment from 'moment';
import strftime from 'strftime';
import EventSearch from '../dashboard/Search'
import Vue from 'vue';

import CloudRecEvent from './Event.vue'
import EventModel from '@/models/event.js'

export default {
  props: {
    "issearch": {
      type: Boolean,
      default: true
    },
    "start": Number,
    "end": Number
  },
  filters: datelib,
  components: {
    CloudRecEvent,
    EventSearch
  },
  data () {
  	var start_date = moment(0).startOf('day').toDate();
	  var end_date = moment().endOf('day').toDate();
    return {
      event_search: "",
      show_button: false,
      search_menu: false,
    	headers: [],
      channel: undefined,
      events: [],
      page_size: 50,
      grouped_events: [],
      events_by_uuid: {},
      filters: {
        daterange: {
          start: start_date,
          end: end_date
        },
        states: ["active"],
        offset: 0
      },
  	}
  },
  computed: {
    event_count () {
      return Object.values(this.events_by_uuid).length;
    }
  },
  mounted: function() {
  	this.connect_ws();
    var self = this;
  },
  methods: {
    visibility_changed (newVal) {
      if (newVal == true) {
        this.load_next();
      }
    },
    get_grouped_events: function(events) {
      var self = this;
      var ret = {};

/*      var filtered_events = _.filter(events, function(event) {
        var ch = EventModel.output_channel(event);
        if (typeof(ch) == "undefined") return true; // Ei löydy kanavaa, ei filtteröidä pois
        console.log(ch.configuration.clip);
        if (typeof(ch.configuration.clip) != "undefined") return true;
        return false;
      }); */

      _.each(events, function(event) {
        var d = moment(event.cached_start_time * 1000).startOf('day').unix();
        if (typeof(ret[d]) == "undefined") ret[d] = [];
        ret[d].push(event);
      });

			ret = _.map(ret, function(data, idx) {
  			return {timestamp: idx, events: data};
  		});
  		ret = _.sortBy(ret, ["timestamp"]);

      return ret.reverse();
    },
    open_add_event () {
      this.$router.push("/dashboard/event_new");
    },
  	format_date (date) {
  		if (date == moment().startOf('day').unix()) return "Today";
  		return datelib.format_date(date);
  	},
  	sorted(list) {
  		return _.sortBy(list, [function(o) { return o.cached_start_time}, "uuid"]).reverse();
  	},
  	filterEvents () {

      var _filters = _.cloneDeep(this.filters);
      if(typeof(_filters.daterange.start) != "undefined") {
        _filters.daterange.start = moment(_filters.daterange.start).startOf('day').unix();
      }
      if(typeof(_filters.daterange.end) != "undefined") {
        _filters.daterange.end = moment(_filters.daterange.end).endOf('day').unix();
      }
      _filters.limit = this.page_size;
      _filters.order_by = [{"cached_start_time":"desc"}, {"uuid": "desc"}];
      this.channel.push("filter", _filters);
    },
    is_between_dates(event) {
      var _filters = _.cloneDeep(this.filters);
      var start_date = moment(_filters.daterange.start).startOf('day').unix();
      var end_date = moment(_filters.daterange.end).endOf('day').unix();
      return (event.cached_end_time > start_date && event.cached_start_time < end_date);
    },
    add_event_to_list(event) {
      var self = this;
      if (event.state == "active" && self.is_between_dates(event) ) {
        Vue.set(self.events_by_uuid, event.uuid, event);
      } else {
        Vue.delete(self.events_by_uuid, event.uuid);
      }
    },
    load_next() {
      console.log("Loading next");
      this.filters.offset = this.filters.offset + this.page_size;
      this.filterEvents();
    },
  	connect_ws () {
  		var self = this;
	    this.channel = this.$socket.channel("events:all");
  	  this.channel.on("init", function(msg) {
      	self.filterEvents();
    	});

    	this.channel.on("events", function(msg) {
        self.show_button = true;
        _.each(msg.events, function(event) {
          self.add_event_to_list(event);
        });

        Vue.nextTick(function () {
          self.grouped_events = self.get_grouped_events(Object.values(self.events_by_uuid));
        });
    	});
    	this.channel.on("event-update", function(msg) {

        var event = msg.data;
        self.add_event_to_list(event);

        Vue.nextTick(function () {
          self.grouped_events = self.get_grouped_events(Object.values(self.events_by_uuid));
        });
    	});
    	this.channel.join();
  	}
  },
  beforeDestroy: function() {
    this.channel.leave();
  }


}
</script>

<style scoped>

</style>